import Layout from '@layout/Index'

export const market = [
  {
    path: '/market',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "market-table" */ './pages/MarketTable.vue'),
        name: '门店列表',
        meta: {
          title: '门店列表',
        },
      },
      {
        path: 'upload/table',
        component: () => import(/* webpackChunkName: "market-upload/table" */ './pages/MarketUplaodTable.vue'),
        name: '门店上传',
        meta: {
          title: '门店上传',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "market-create" */ './pages/MarketForm.vue'),
        name: '门店添加',
        meta: {
          title: '门店添加',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "market-create" */ './pages/MarketForm.vue'),
        name: '门店修改',
        meta: {
          title: '门店修改',
        },
      },
      {
        path: 'log/:id',
        component: () => import(/* webpackChunkName: "market-log" */ './pages/MarketLogTable.vue'),
        name: '门店信息更新日志',
        meta: {
          title: '门店信息更新日志',
        },
      },
      {
        path: 'location',
        component: () => import(/* webpackChunkName: "market-location" */ './pages/MarketLocation.vue'),
        name: '门店经纬度修改',
        meta: {
          title: '门店经纬度修改',
        },
      },
      {
        path: 'cs-location-log',
        component: () => import(/* webpackChunkName: "market-cs-location-log" */ './pages/MarketCsLocationLogTable.vue'),
        name: '客服修改经纬度日志',
        meta: {
          title: '客服修改经纬度日志',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/market/market.route.js